import { render, staticRenderFns } from "./remaingoodslist.vue?vue&type=template&id=7957ad14&scoped=true&"
import script from "./remaingoodslist.vue?vue&type=script&lang=js&"
export * from "./remaingoodslist.vue?vue&type=script&lang=js&"
import style0 from "./remaingoodslist.vue?vue&type=style&index=0&id=7957ad14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7957ad14",
  null
  
)

export default component.exports